import React, { useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const FAQSection = () => {
  const { language } = useLanguage();
  const [openFAQ, setOpenFAQ] = useState(null);

  const toggleFAQ = (index) => {
    setOpenFAQ(openFAQ === index ? null : index);
  };

  const content = {
    en: {
      title: "Frequently Asked Questions",
      faqs: [
        {
          question: "What is Audiosum?",
          answer: "Audiosum is dedicated to all professionals, students, and researchers, serving as your AI audio assistant. It helps you get summaries from any audio or video content, giving you a quick overview of everything you need to know. With AI-powered transcription, summaries, and insights, it saves you 60% of your time in processing audio content."
        },
        {
          question: "What audio and video formats does Audiosum support?",
          answer: "Audiosum supports all major audio formats including MP3, WAV, M4A, OGG, FLAC, and video formats like MP4, AVI, MOV, MKV. Files up to 1GB are supported for processing with 99%+ accuracy."
        },
        {
          question: "What Summarizers does Audiosum offer?",
          answer: "Audiosum offers a variety of summarizers to meet different needs. These include the Audio Summarizer, Video Summarizer, Meeting Transcriber, Lecture Summarizer, Podcast Summarizer, Interview Transcriber, and more specialized tools for research and business content."
        },
        {
          question: "Can I use Audiosum to get a full transcript of audio/video?",
          answer: "Yes, Audiosum can generate full transcripts of audio and video content. The transcription feature allows you to read through the content at your own pace, search for specific information, and export in multiple formats including DOCX, PDF, TXT, and MD."
        },
        {
          question: "Can I use Audiosum for legal or business documents?",
          answer: "Yes, Audiosum is particularly useful for legal recordings, business meetings, and professional content. It can quickly process contracts discussions, meeting recordings, and other professional audio, highlighting key points and action items while maintaining security and confidentiality."
        },
        {
          question: "How accurate is the AI transcription and summarization?",
          answer: "Our AI provides 99%+ accuracy in transcription and summarization across 95+ languages with advanced context understanding, speaker identification, and sentiment analysis. The accuracy is continuously improved through machine learning."
        },
        {
          question: "Is Audiosum really free to use?",
          answer: "Yes! Our free trial offers 10 uploads and/or 120 transcription minutes per month, plus 30 live transcription minutes. After exceeding these limits, you'll need to upgrade to continue using our professional-quality summaries and transcriptions with advanced features and unlimited processing."
        },
        {
          question: "How do I cancel my subscription?",
          answer: "You can cancel your subscription by logging into your account on audiosum.app and going to the My Plan page. Your access will continue until the end of your billing period."
        },
        {
          question: "What should I do if I encounter issues while using the service?",
          answer: "You can send us an email at support@audiosum.app. Our support team is available to help with technical issues, feature questions, and account management."
        }
      ]
    },
    ar: {
      title: "الأسئلة المتكررة حول لخص",
      faqs: [
        {
          question: "ما هو لخص؟",
          answer: "لخص مخصص لجميع المحترفين والطلاب والباحثين، ويعمل كمساعد الذكاء الاصطناعي الصوتي. يساعدك في الحصول على ملخصات من أي محتوى صوتي أو مرئي، مما يوفر لك 60% من الوقت في معالجة المحتوى الصوتي."
        },
        {
          question: "ما تنسيقات الصوت والفيديو التي يدعمها لخص؟",
          answer: "يدعم لخص جميع تنسيقات الصوت الرئيسية بما في ذلك MP3 و WAV و M4A و OGG و FLAC وتنسيقات الفيديو مثل MP4 و AVI و MOV و MKV. الملفات حتى 1GB مدعومة بدقة 99%+."
        },
        {
          question: "ما أدوات التلخيص التي يقدمها لخص؟",
          answer: "يقدم لخص مجموعة متنوعة من أدوات التلخيص لتلبية الاحتياجات المختلفة. تشمل ملخص الصوت، ملخص الفيديو، نسخ الاجتماعات، ملخص المحاضرات، ملخص البودكاست، ونسخ المقابلات."
        },
        {
          question: "هل يمكنني استخدام لخص للحصول على نسخة كاملة من الصوت/الفيديو؟",
          answer: "نعم، يمكن لـ لخص إنشاء نسخ كاملة من المحتوى الصوتي والمرئي. تتيح لك ميزة النسخ قراءة المحتوى بالسرعة التي تناسبك والبحث عن معلومات محددة والتصدير بتنسيقات متعددة."
        },
        {
          question: "هل يمكنني استخدام لخص للمستندات القانونية أو التجارية؟",
          answer: "نعم، لخص مفيد بشكل خاص للتسجيلات القانونية واجتماعات العمل والمحتوى المهني. يمكنه معالجة مناقشات العقود وتسجيلات الاجتماعات مع الحفاظ على الأمان والسرية."
        },
        {
          question: "ما مدى دقة النسخ والتلخيص بالذكاء الاصطناعي؟",
          answer: "يوفر الذكاء الاصطناعي لدينا دقة 99%+ في النسخ والتلخيص عبر أكثر من 95 لغة مع فهم متقدم للسياق وتحديد المتحدث وتحليل المشاعر."
        },
        {
          question: "هل لخص مجاني حقاً؟",
          answer: "نعم! تقدم تجربتنا المجانية 10 رفعات و/أو 120 دقيقة نسخ شهرياً، بالإضافة إلى 30 دقيقة نسخ مباشر. بعد تجاوز هذه الحدود، ستحتاج إلى الترقية للحصول على ملخصات احترافية ومعالجة غير محدودة."
        },
        {
          question: "كيف يمكنني إلغاء اشتراكي؟",
          answer: "يمكنك إلغاء اشتراكك عن طريق تسجيل الدخول إلى حسابك على audiosum.app والذهاب إلى صفحة خطتي. سيستمر وصولك حتى نهاية فترة الفوترة."
        },
        {
          question: "ماذا يجب أن أفعل إذا واجهت مشاكل أثناء استخدام الخدمة؟",
          answer: "يمكنك إرسال بريد إلكتروني إلينا على support@audiosum.app. فريق الدعم لدينا متاح للمساعدة في المشاكل التقنية وأسئلة الميزات وإدارة الحساب."
        }
      ]
    }
  };

  const currentContent = content[language];

  return (
    <div 
      id="faq-section"
      className="container-fluid mb-5 py-5" 
      style={{ 
        background: 'transparent',
        minHeight: '100vh'
      }}
    >
      {/* Center the entire FAQ section */}
      <div className="container d-flex justify-content-center">
        <div className="row justify-content-center w-100">
          <div className="col-12 col-lg-10 col-xl-8">
            {/* Modern Header */}
            <div className="text-center mb-5">
              <h2 className="fw-bold mb-4" style={{ 
                fontSize: 'clamp(2rem, 5vw, 3rem)', 
                color: '#0F172A',
                fontFamily: '"Playfair Display", serif',
                fontWeight: '700',
                textShadow: 'none'
              }}
              data-aos="fade-down"
              >
                {currentContent.title}
              </h2>
              {language === 'ar' && (
                <p className="mb-0" style={{ 
                  fontSize: '1.1rem',
                  fontFamily: '"Inter", sans-serif'
                }}>
                  إجابات شاملة على أسئلتك الأكثر شيوعاً
                </p>
              )}
              {language === 'en' && (
                <p className="mb-0" style={{ 
                  fontSize: '1.1rem'
                }}>
                  Comprehensive answers to your most common questions
                </p>
              )}
            </div>

            {/* Modern FAQ Items - Oval Rectangular Design */}
            <div className="faq-container">
              {currentContent.faqs.map((faq, index) => (
                <div 
                  key={index} 
                  className="faq-item mb-4"
                  data-aos={index % 2 === 0 ? "fade-right" : "fade-left"}
                  data-aos-delay={index * 100}
                >
                  {/* Question Button - Oval Rectangular */}
                  <button
                    className={`faq-question w-100 text-start ${openFAQ === index ? 'active' : ''}`}
                    onClick={() => toggleFAQ(index)}
                    style={{
                      background: openFAQ === index 
                        ? 'linear-gradient(135deg, #6C3AED 0%, #7C3AED 100%)'
                        : 'rgba(255, 255, 255, 0.95)',
                      color: openFAQ === index ? '#ffffff' : '#1a202c',
                      border: 'none',
                      borderRadius: '25px',
                      padding: '1.25rem 2rem',
                      fontSize: '1.1rem',
                      fontWeight: '600',
                      fontFamily: '"Inter", "Roboto", sans-serif',
                      transition: 'all 0.3s ease',
                      boxShadow: openFAQ === index 
                        ? '0 10px 30px rgba(108, 58, 237, 0.3)'
                        : '0 5px 20px rgba(0, 0, 0, 0.1)',
                      backdropFilter: 'blur(10px)',
                      position: 'relative',
                      overflow: 'hidden'
                    }}
                  >
                    <div className="d-flex justify-content-between align-items-center">
                      <span style={{ flex: 1, paddingRight: '1rem' }}>
                        {faq.question}
                      </span>
                      <i className={`fas ${openFAQ === index ? 'fa-minus' : 'fa-plus'}`} 
                         style={{ 
                           fontSize: '1rem',
                           transition: 'transform 0.3s ease'
                         }} 
                      />
                    </div>
                  </button>

                  {/* Answer Panel */}
                  <div 
                    className={`faq-answer ${openFAQ === index ? 'show' : ''}`}
                    style={{
                      maxHeight: openFAQ === index ? '500px' : '0',
                      overflow: 'hidden',
                      transition: 'all 0.4s ease',
                      marginTop: openFAQ === index ? '10px' : '0'
                    }}
                  >
                    <div 
                      style={{ 
                        background: 'rgba(255, 255, 255, 0.9)',
                        borderRadius: '20px',
                        padding: '1.5rem 2rem',
                        fontSize: '1rem',
                        lineHeight: '1.7',
                        color: '#4a5568',
                        fontFamily: '"Inter", "Roboto", sans-serif',
                        backdropFilter: 'blur(10px)',
                        boxShadow: '0 5px 25px rgba(0, 0, 0, 0.1)',
                        border: '1px solid rgba(255, 255, 255, 0.2)'
                      }}
                    >
                      {faq.answer}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Custom CSS for enhanced styling */}
      <style jsx>{`
        .faq-question:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 30px rgba(108, 58, 237, 0.2) !important;
        }

        .faq-question.active:hover {
          box-shadow: 0 12px 35px rgba(108, 58, 237, 0.4) !important;
        }

        .faq-question::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: linear-gradient(45deg, transparent 30%, rgba(255,255,255,0.1) 50%, transparent 70%);
          transform: translateX(-100%);
          transition: transform 0.6s ease;
        }

        .faq-question:hover::before {
          transform: translateX(100%);
        }

        .faq-answer.show {
          animation: slideDown 0.4s ease;
        }

        @keyframes slideDown {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        /* Mobile responsiveness */
        @media (max-width: 768px) {
          .faq-question {
            padding: 1rem 1.5rem !important;
            font-size: 1rem !important;
          }

          .faq-answer div {
            padding: 1.25rem 1.5rem !important;
            font-size: 0.95rem !important;
          }

          .faq-question:hover {
            transform: none !important;
          }
        }

        /* Small devices */
        @media (max-width: 576px) {
          .faq-question {
            padding: 0.875rem 1.25rem !important;
            font-size: 0.95rem !important;
            border-radius: 20px !important;
          }

          .faq-answer div {
            border-radius: 15px !important;
            padding: 1rem 1.25rem !important;
          }
        }
      `}</style>
    </div>
  );
};

export default FAQSection;